export const formatCurrency = amount => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(amount)
}

export const formatNumber = number => {
  return new Intl.NumberFormat("th-TH").format(number)
}

/**
 * Calculate percentage of an amount
 * @param {number} amount - The base amount
 * @param {number} percentage - Percentage value (0-100)
 * @returns {string} The calculated amount after applying percentage (2 decimal places)
 */
export const calculatePercentage = (amount, percentage = 0) => {
  return ((amount * percentage) / 100).toFixed(2)
}
